function Separator() {
  return (
    <div className="w-full h-[1px] bg-[#1E1E1E]"></div>
  );
}

export default Separator;